(function ($) {
  class wooFilters {
    constructor() {
      this.mainSelector = '[data-role=products-filters]';
      this.sliderSelector = '[data-role=rangeSlider]';
      this.filterLine = '.product-filter';

      $(() => {
        this.forms = $(this.mainSelector);
        this.sliders = this.forms.find(this.sliderSelector);

        this.initRanges();
        this.setListeners();
      });

    }

    setListeners() {
      this.forms.on('change', 'select', (e) => this.changeSelect(e));
      this.forms.on('change', '[type=checkbox]', (e) => this.changeCheckbox(e));


      this.forms.on('click', '[type=submit]', (e) => this.beforeSubmit(e));
      this.forms.on('click', '[type=reset]', (e) => this.resetForm(e));
    }

    initRanges() {
      this.sliders.each((i, item) => {
        var $range = $(item),
          $cont = $range.closest('fieldset'),
          args = {};

        if ($range.data('id') === 'price') {
          args['onChange'] = (data) => {
            $cont.find('#min_price').val(data['from']);
            $cont.find('#max_price').val(data['to']);
          }
        } else {
          args['hide_min_max'] = true;
          args['onChange'] = (data) => {
            var $input = data.input,
              from = data.from,
              to = data.to;

            let inputId = $input.data('tax');
            let input = $input.closest('form').find(`[data-id=${inputId}]`);

            if ($input.data('grid')) {
              var values = $input.data('values').split(',');

              var new_values = values.slice(from, to + 1);
              $input.attr('data-current', new_values);

              input.val(new_values);
            } else {
              let values = $input.val();

              // input.val(values.replace(';', ','));
              input.val(values);
            }
          }
        }

        $range.ionRangeSlider(args);
      });
    }

    beforeSubmit(e) {
      e.preventDefault();
      let button = $(e.target),
        form = button.closest('form');

      this.sliders.each((i, item) => {
        var $input = $(item);

        if ($input.data('id') === 'price') {
          var value = $input.val().split(';');
          $input.val(value.join(','));
        } else {
          $input.val($input.data('current'));
        }
      });

      form.find('[data-role=hidden-input], [type=hidden]').each((i, item) => {
        let input = $(item);

        if (input.val() === '') {
          input.removeAttr('name');
        }
      });

      form.submit();
    }

    changeSelect(e) {
      let select = $(e.target),
        inputId = select.data('tax'),
        value = select.val();

      let input = select.closest('form').find(`[data-id=${inputId}]`);

      input.val(value);
    }

    changeCheckbox(e) {
      let checkbox = $(e.target),
        checked = checkbox.prop('checked'),
        value = checkbox.val(),
        inputId = checkbox.data('tax');

      let input = checkbox.closest('form').find(`[data-id=${inputId}]`);
      let inputValue = input.val();

      if (checked) {
        input.val(this.addToValue(inputValue, value));
      } else {
        input.val(this.removeFromValue(inputValue, value));
      }
    }

    resetForm(e) {
      console.log(e);
      // console.log(window.location);
      if ( window.location.search ) {
        let href = window.location.href.split('?');

        window.location.href = href[0];
      }

      let button = $(e.target),
        form = button.closest('form');

      form.find('input').each((i, item) => {
        let input = $(item),
          type = input.attr('type');

        switch (type) {
          case 'text':
          case 'number':
            input.removeAttr('value');
            break;

          case 'checkbox':
          case 'radio':
            input.removeAttr('checked');
            break;
        }
      });

      form.find(this.sliderSelector).each((i, item) => {
        let input = $(item),
          slider = input.data("ionRangeSlider");

        this.resetSlider(slider);
      });

      form.find('select').val('').trigger('change');
      form.find('[data-role=hidden-input]').removeAttr('value');
    }

    resetSlider(slider) {
      slider.update({
        from: slider.options.min,
        to: slider.options.max,
      });
    }

    addToValue(oldValue, newValue) {
      let values = oldValue.split(',');

      if (values[0] === '') {
        values = [];
      }

      if (values.indexOf(newValue) === -1) {
        values.push(newValue);
      }

      return values.join(',');
    }

    removeFromValue(oldValue, newValue) {
      let values = oldValue.split(',');

      let index = values.indexOf(newValue);
      if (index > -1) {
        values.splice(index, 1)
      }

      return values.join(',');
    }
  }

  new wooFilters();
})(jQuery);
